/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_3_WInputs */

const en_cp_jr_3_w = /** @type {(inputs: Cp_Jr_3_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`end of semester`)
};

const id_cp_jr_3_w = /** @type {(inputs: Cp_Jr_3_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`akhir semester`)
};

/**
* | output |
* | --- |
* | "end of semester" |
*
* @param {Cp_Jr_3_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_3_w = /** @type {((inputs?: Cp_Jr_3_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_3_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_3_w(inputs)
	return en_cp_jr_3_w(inputs)
});